import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ToastController } from '@ionic/angular';
import { StorageService } from './storage.service';
import { MobileSettingsService } from './mobile-settings.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineModeService {
  private statusStorageSubject = new BehaviorSubject<boolean>(true);
  private syncRequestedSubject = new Subject<void>();
  private readonly statusLoaded: Promise<boolean>;

  statusStorage$ = this.statusStorageSubject.asObservable();
  syncRequested$ = this.syncRequestedSubject.asObservable();

  constructor(
    private storage: StorageService,
    private toastCtrl: ToastController,
    private mobileSettings: MobileSettingsService
  ) {
    this.statusLoaded = this.storage.getObject('statusStorage_difritz').then(async (status) => {
      const online = status == null ? true : Boolean(status);
      this.statusStorageSubject.next(this.mobileSettings.current.offline_mode_enabled ? online : true);
      if (status == null) {
        await this.storage.setObject('statusStorage_difritz', true);
      }
      if (!this.mobileSettings.current.offline_mode_enabled && !online) {
        await this.storage.setObject('statusStorage_difritz', true);
      }
      return this.statusStorageSubject.value;
    });
    this.mobileSettings.settings$.subscribe((settings) => {
      if (!settings.offline_mode_enabled && !this.statusStorageSubject.value) {
        this.setStatus(true);
      }
    });
  }

  whenReady(): Promise<boolean> {
    return this.statusLoaded;
  }

  offLine(statusStorage: boolean): void {
    if (!statusStorage && !this.mobileSettings.current.offline_mode_enabled) {
      this.toastCtrl.create({
        message: 'El modo offline está deshabilitado por la configuración.',
        duration: 2500,
        position: 'middle',
        cssClass: 'style-toast-warning-class'
      }).then((toastData) => toastData.present());
      return;
    }

    this.toastCtrl.create({
      message: statusStorage ? 'Modo Online: Activo.' : 'Modo OffLine: Activo.',
      duration: 2500,
      position: 'middle',
      cssClass: statusStorage ? 'style-toast-class' : 'style-toast-sync-class'
    }).then((toastData) => {
      toastData.present();
    });

    this.setStatus(statusStorage);
  }

  private setStatus(statusStorage: boolean): void {
    this.statusStorageSubject.next(statusStorage);
    this.storage.setObject('statusStorage_difritz', statusStorage);

    if (statusStorage) {
      this.syncRequestedSubject.next();
    }
  }
}
